import { DisruptionsTable } from './components/DisruptionsTable'
import styles from './Disruptions.module.scss'
import { useGetAreas } from '@/modules/Areas/api/useGetAreas'
import { useAreaStore } from '@/modules/Areas/store'
import { useAuthStore } from '@/store/auth-store'
import { Role } from '@/types/auth'
import { TreeSelect } from '@/ui/Select'
import clsx from 'clsx'

const DisruptionsSelect = () => {
    const { data: areas } = useGetAreas()
    const { selectedAreaCode, setSelectedAreaCode } = useAreaStore()

    const areaOptions = areas?.map((area) => ({ value: area.code, label: area.title })) || []

    const handleAreaChange = (value: string) => {
        setSelectedAreaCode(value)
    }

    return (
        <TreeSelect
            placeholder="Disruptions"
            options={[
                { value: 'all', label: 'All disruptions' },
                ...areaOptions,
                { value: 'night', label: 'Night Network' },
            ]}
            value={selectedAreaCode}
            disabled={false}
            onChange={handleAreaChange}
        />
    )
}

export const AllDisruptions = () => {
    const { role } = useAuthStore()

    return (
        <section
            className={clsx(styles.root, {
                [styles.fullHeight]: role && [Role.PerformanceManager, Role.Reader].includes(role),
            })}
        >
            <header className={styles.header}>
                <div className={styles.details}>
                    <DisruptionsSelect />
                </div>
            </header>
            <div className={styles.container}>
                <DisruptionsTable />
            </div>
        </section>
    )
}
